export default __webpack_public_path__ + "media/images/features/ambassador/profiles/kyonkyon_san-170d83010d2f422f254efe86cdf311e3.jpg";